module.exports = __webpack_public_path__ + "static/media/wazeba-white.6f22d64d.gif";